<template>
  <div id="UserList">
    <div class="list_view list_flex">
      <a-menu style="width: 200px" mode="vertical" :selectedKeys="defaultData" @click="handleClick">
        <a-menu-item key="1">
          <router-link to="/userList/useraccount">我的账号</router-link>
        </a-menu-item>
        <a-menu-item key="5" v-if="roleID === 3">
          <router-link to="/userList/myClass">我的班级</router-link>
        </a-menu-item>
        <a-menu-item key="2">
          <router-link to="/userList/userpassword">密码设置</router-link>
        </a-menu-item>
         <a-menu-item key="7">
            <router-link to="/userList/bangwecaht">绑定微信</router-link>
        </a-menu-item>
        <a-sub-menu>
          <template slot="title"><span></span></template>
        </a-sub-menu>
        <a-menu-item key="3">
          <router-link v-if="roleID === 1" to="/userList/accountset">人员管理</router-link>
          <a-tooltip v-else class="showHide" placement="topLeft">
            <template slot="title">仅限超级管理员使用</template>
            人员管理
          </a-tooltip>
        </a-menu-item>
        <a-menu-item key="4">
          <router-link v-if="roleID === 1" to="/userList/schoolset">学校设置</router-link>
          <a-tooltip v-else class="showHide" placement="topLeft">
            <template slot="title">仅限超级管理员使用</template>
            学校设置
          </a-tooltip>
        </a-menu-item>
        <a-sub-menu>
          <template slot="title"><span></span></template>
        </a-sub-menu>
        <a-menu-item key="5" v-if="roleID === 1">
          <router-link to="/userList/operationLog">操作日志</router-link>
        </a-menu-item>
        <a-menu-item key="6" v-if="roleID === 1">
          <router-link to="/userList/loginLog">账号安全</router-link>
        </a-menu-item>
      </a-menu>
      <div class="list_con">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'UserList',
    data () {
      return {
        defaultData: ['1'],
        roleID: null
      }
    },
    computed: {
      ...mapState([
      ])
    },
    methods: {
      handleClick({...item}) {
         this.defaultData = item.keyPath
        // console.log('click ', item)
      }
    },
    mounted () {
      this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
    }
  }
</script>

<style>
  #UserList {
    width: 100%;
    height: 100%;
  }
  #UserList .list_flex {
    display: flex;
  }
  #UserList .list_view {
    width: 100%;
  }
  #UserList .list_view .list_con {
    flex: 1;
    padding: 32px 0px 0px 24px;
    box-sizing: border-box;
  }
  #UserList .showHide {
    display: block;
    color: #BFBFBF;
  }
  .ant-menu {
    background-color: transparent;
    padding-top: 28px;
  }
  .ant-menu-vertical {
    border: none;
  }
  .ant-menu-item:hover {
    background: #F5F5F5!important;
  }
  .ant-menu-item:hover>a, .ant-menu-item-selected > a  {
    color: #51BF94;
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: transparent;
  }
  .ant-menu-submenu, .ant-menu-submenu div {
    height: 5px!important;
    line-height: 0px!important;
    margin-bottom: 13px;
  }
  .ant-menu-submenu span {
    display: inline-block;
    width: 25px;
    height: 1px;
    background: #E8E8E8;
  }
  .ant-menu-submenu i {
    display: none;
  }
</style>